import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs, onMounted, getCurrentInstance } from "vue";
import { LogService } from "@/services";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileItem',
  props: {
    label: { default: "Default title" },
    txt: { default: "" },
    link: { default: "" },
    isEmail: { type: Boolean, default: false },
    html: { default: "" },
    bodyClass: { default: "" },
    htmlFullWidth: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { label: string, txt: string, link: string, isEmail: boolean, html: string, bodyClass: string, htmlFullWidth: boolean };


const { label, txt, link, isEmail, html, bodyClass, htmlFullWidth } =
  toRefs(props);
const isFullWidth = computed(() => !!html.value && htmlFullWidth);
const instance = getCurrentInstance();
const { slots } = instance?.proxy;

onMounted(() => {
  if (html.value === "No information available." && slots?.body) {
    LogService.error(
      `Component with label: ${label.value} might be incorrectly visible. Check v-if's and/or for missing data`
    );
  }
});

return { __sfc: true,props, label, txt, link, isEmail, html, bodyClass, htmlFullWidth, isFullWidth, instance, slots }
}

})